import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { KibSelect } from '@chewy/kib-fields-new-react'
import type { Field, Role, User } from '@pbt/pbt-ui-components'

import { getCurrentBusinessId } from '~/store/reducers/auth'
import { getRolesMap } from '~/store/reducers/roles'

import '@chewy/kib-fields-new-styles/dist/styles/kib-select.css'

interface MemberCommunicationRoleSelectProps {
  disabled: boolean
  teamMember: User
  titleRoleId: Field
}

export const MemberCommunicationRoleSelect = ({
  disabled,
  teamMember,
  titleRoleId,
}: MemberCommunicationRoleSelectProps) => {
  const { t } = useTranslation('Admin')
  const currentBusinessId = useSelector(getCurrentBusinessId)
  const rolesMap = useSelector(getRolesMap)

  const assignedRoles: Role[] = useMemo(() => {
    const roleIds = (teamMember.businessToRoleList ?? [])
      .filter((br) => br.business === currentBusinessId)
      .map((br) => br.role)

    return roleIds.map((id) => rolesMap[id]).filter(Boolean)
  }, [teamMember.businessToRoleList, currentBusinessId, rolesMap])

  return (
    <KibSelect
      disabled={disabled}
      label={t('Admin:MEMBER.COMMUNICATION_ROLE')}
      value={titleRoleId.value}
      onChange={(e: any) => titleRoleId.setValue(e.target.value)}
    >
      <option disabled hidden value="">
        {`${t('Common:SELECT_ACTION')}...`}
      </option>
      {assignedRoles.map((role) => (
        <option key={role.id} value={role.id}>
          {role.nameTranslation ?? role.name}
        </option>
      ))}
    </KibSelect>
  )
}
